import { useField, useFormikContext } from 'formik';

import { TextArea, TextAreaProps } from './TextArea';

interface FormikTextAreaProps extends TextAreaProps {
    name: string;
}

export const FormikTextArea = (props: FormikTextAreaProps) => {
    const [field, meta, helpers] = useField(props.name);
    const { validateOnChange } = useFormikContext();

    return (
        <TextArea
            caption={meta.touched && meta.error && typeof meta.error === 'string' ? meta.error : props.caption}
            negative={meta.touched && !!meta.error}
            {...props}
            {...field}
            onChange={(event) => {
                field.onChange(event);
                if (!validateOnChange && meta.error) {
                    helpers.setError(undefined);
                }
            }}
        />
    );
};
